import React from "react";
import HelpArticles from "../components/HelpArticles";

const HelpIndex = () => {
  return (
    <>
      <h1 className="heading-1">Help & Support</h1>
      <p className="title-1 ">Popular Topics</p>
      <HelpArticles />
    </>
  );
};

export default HelpIndex;
